import { Injectable, inject } from '@angular/core';
import { CommercialOutageBuilderService } from 'src/app/services/builder/commercial-outage-builder.service';
import { Observable } from 'rxjs';
import { queryForCommercialOutages } from 'src/app/graphql/commercial-services/commercial-outages/query-for-commercial-outages';
import { getCommercialOutage } from 'src/app/graphql/commercial-services/commercial-outages/get-commercial-outage';
import {
  CommercialOutage,
  CommercialOutageConnection,
  CommercialOutageSortOrQuery,
} from 'src/app/model/commercial-services/commercial-outage';
import { BaseAppSyncService } from '../base-app-sync.service';
import { CommercialOutageUpdateDto } from 'src/app/model/commercial-services/commercial-outage-update-dto';
import {
  createCommercialOutage,
  updateCommercialOutage,
} from 'src/app/graphql/commercial-services/commercial-outages/save-commercial-outage';

@Injectable({
  providedIn: 'root',
})
export class CommercialOutageApiService extends BaseAppSyncService {
  private _commercialOutageBuilder = inject(CommercialOutageBuilderService);

  createCommercialOutage(
    input: CommercialOutageUpdateDto
  ): Observable<CommercialOutage> {
    return this.mutate(
      createCommercialOutage,
      { input },
      (item: any) => this._commercialOutageBuilder.buildCommercialOutage(item),
      'createCommercialOutage'
    );
  }

  updateCommercialOutage(
    id: string,
    input: CommercialOutageUpdateDto
  ): Observable<CommercialOutage> {
    return this.mutate(
      updateCommercialOutage,
      { id, input },
      (item: any) => this._commercialOutageBuilder.buildCommercialOutage(item),
      'updateCommercialOutage'
    );
  }

  getCommercialOutage(
    id: string,
    version?: number
  ): Observable<CommercialOutage> {
    if (version !== undefined && (!Number.isInteger(version) || version < 0)) {
      throw new Error(
        'Commercial outage version must be a non-negative integer.'
      );
    }
    return this.query(
      getCommercialOutage,
      version === undefined ? { id } : { id, version },
      (item: any) => this._commercialOutageBuilder.buildCommercialOutage(item),
      'getCommercialOutage'
    );
  }

  queryForCommercialOutages(
    limit: number,
    page: number,
    query: CommercialOutageSortOrQuery,
    sort: CommercialOutageSortOrQuery
  ): Observable<CommercialOutageConnection> {
    return this.query(
      queryForCommercialOutages,
      { limit, page, query, sort },
      (i: any) =>
        this._commercialOutageBuilder.buildCommercialOutageConnection(i),
      'queryForCommercialOutages'
    );
  }
}
